var _defs, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path3, _path4, _circle, _path5, _circle2, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _ellipse, _path6, _path7, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _ellipse2, _path8, _path9, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _ellipse3, _path0, _path1, _circle3, _path10, _circle4, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMytermsthumbnail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1521.7 1205.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-4,.cls-5,.cls-8,.cls-9{stroke:#006de1;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-4,.cls-5,.cls-9{stroke-linejoin:round;stroke-width:0.5px;}.cls-1{fill:url(#linear-gradient);}.cls-2,.cls-7{fill:#006de1;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{opacity:0.1;fill:url(#linear-gradient-5);}.cls-7{opacity:0.05;}.cls-8{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-13);}.cls-17{fill:url(#linear-gradient-14);}.cls-18{fill:url(#linear-gradient-15);}.cls-19{fill:url(#linear-gradient-16);}.cls-20{fill:url(#linear-gradient-17);}.cls-21{fill:url(#linear-gradient-18);}.cls-22{fill:url(#linear-gradient-19);}.cls-23{fill:url(#linear-gradient-20);}.cls-24{fill:url(#linear-gradient-21);}.cls-25{fill:url(#linear-gradient-22);}.cls-26{fill:url(#linear-gradient-23);}.cls-27{fill:url(#linear-gradient-24);}.cls-28{fill:url(#linear-gradient-25);}.cls-29{fill:url(#linear-gradient-26);}.cls-30{fill:url(#linear-gradient-27);}.cls-31{fill:url(#linear-gradient-28);}.cls-32{fill:url(#linear-gradient-29);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 595.65,
    y1: 177.45,
    x2: 914.44,
    y2: 177.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6f2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 827.51,
    y1: 1064.32,
    x2: 827.51,
    y2: 814.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 718.78,
    y1: 864.5,
    x2: 648.72,
    y2: 1014.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 727.29,
    y1: 874.45,
    x2: 782.4,
    y2: 756.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 755.04,
    y1: 1085.55,
    x2: 755.04,
    y2: 1182.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006de1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6f2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1340.04,
    y1: 352.01,
    x2: 1340.09,
    y2: 352.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1195.15,
    y1: 545.8,
    x2: 1341.43,
    y2: 545.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1339.95,
    y1: 352.03,
    x2: 1340.04,
    y2: 352.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1340.62,
    y1: 510.92,
    x2: 1485.56,
    y2: 510.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1195.82,
    y1: 426.33,
    x2: 1484.26,
    y2: 426.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1195.15,
    y1: 388.8,
    x2: 1339.95,
    y2: 388.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1340.04,
    y1: 353.88,
    x2: 1347.53,
    y2: 353.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1272.03,
    y1: 364.98,
    x2: 1407.17,
    y2: 364.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 169.42,
    y1: 350.12,
    x2: 169.46,
    y2: 350.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 24.53,
    y1: 543.9,
    x2: 170.8,
    y2: 543.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 169.33,
    y1: 350.14,
    x2: 169.42,
    y2: 350.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 170,
    y1: 509.03,
    x2: 314.93,
    y2: 509.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 25.2,
    y1: 424.43,
    x2: 313.64,
    y2: 424.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 24.53,
    y1: 386.91,
    x2: 169.33,
    y2: 386.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 169.42,
    y1: 351.99,
    x2: 176.91,
    y2: 351.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 102.44,
    y1: 364.98,
    x2: 237.59,
    y2: 364.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 759.84,
    y1: 497.47,
    x2: 759.88,
    y2: 497.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 614.95,
    y1: 691.26,
    x2: 761.22,
    y2: 691.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 759.75,
    y1: 497.49,
    x2: 759.84,
    y2: 497.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 760.42,
    y1: 656.39,
    x2: 905.35,
    y2: 656.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 615.62,
    y1: 571.79,
    x2: 904.06,
    y2: 571.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 614.95,
    y1: 534.26,
    x2: 759.75,
    y2: 534.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 759.84,
    y1: 499.34,
    x2: 767.33,
    y2: 499.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 691.26,
    y1: 505,
    x2: 826.41,
    y2: 505,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M821.79,323.42l0,0C716.15,372.12,595.65,295,595.65,178.7v-2.52A159.37,159.37,0,0,1,688.46,31.37h0C793.12-16.74,912.68,58.64,914.38,173.82l0,2.51A159.38,159.38,0,0,1,821.79,323.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M752.86,113.2a11.47,11.47,0,0,1,4.37,0A17.35,17.35,0,0,1,761.8,115l.35.19,54.67,28.29a5,5,0,0,1,2.68,4.4v52.22a17.55,17.55,0,0,1-.62,5.7,11.94,11.94,0,0,1-2.61,4.31,17.31,17.31,0,0,1-4.78,3.17l-.41.22-53.76,27.82a5,5,0,0,1-2.28.55,5,5,0,0,1-2.28-.55L699,213.53l-.41-.22a17.5,17.5,0,0,1-4.79-3.17,12.23,12.23,0,0,1-2.61-4.31,17.6,17.6,0,0,1-.61-5.71V147.91a5,5,0,0,1,2.67-4.4l54.67-28.29.35-.18A17.1,17.1,0,0,1,752.86,113.2Zm1.49,9.89q-.95.45-1.86.93l-45.92,23.77L755,171.51l48.47-23.72L757.6,124c-.62-.32-1.24-.63-1.87-.93l-.38-.16m-5.27,105.86V180.12l-49.57-24.26v43.79c0,1.24,0,1.94,0,2.48l.06.52a2,2,0,0,0,.37.63,4.91,4.91,0,0,0,.43.27c.45.28,1.07.6,2.17,1.17Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "899.98 990.45 755.04 1064.32 755.04 887.39 897.62 814.93 899.98 990.45"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "610.11 990.45 755.04 1064.32 755.04 887.39 612.46 814.93 610.11 990.45"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "897.62 814.93 755.04 887.39 612.46 814.93 759.39 745.52 897.62 814.93"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "852.64 1133.06 755.04 1182.66 657.45 1133.06 758.02 1085.55 852.64 1133.06"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "759 747.11 756.48 745.52 756.47 745.54 756.43 745.52 756.43 745.56 707.47 776.14 707.69 776.29 707.47 776.42 756.9 876.88 756.9 876.94 756.92 876.9 756.93 876.94 756.93 876.88 805.67 775.9 759 747.11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M854.82,932.68,856,888.46l-21.86,38-26.39-12.72-2.12,77.07,21.86-38,26.38,12.71.53-19.28-4,8.48-16.37-7.62,9.21-19.78Zm-32.24,9.23-8.25-3.84,3.84-8.24,8.24,3.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M700.57,978.6a58.94,58.94,0,0,1-23.09-8.21A73.32,73.32,0,0,1,646,929.72a59.05,59.05,0,0,1-2.15-24.46l.52-4L667,904.12l1.09,19.73-12.34,9.64a59.84,59.84,0,0,0,3.8,7.7,57.64,57.64,0,0,0,4.77,6.95,63.4,63.4,0,0,0,5.41,6.1,66,66,0,0,0,6.54,5.66l12.55-9.71,18.69,6.37-2.87,22.55Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 470.62,
    cy: 366.5,
    r: 9.84
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.46,386.15l56.28-28.87A159.5,159.5,0,0,1,435,352.84L691.56,464.06a159.51,159.51,0,0,0,126.9,0L1075,352.84a159.5,159.5,0,0,1,136.28,4.44l56.27,28.87"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 924.43,
    cy: 419.23,
    r: 9.84
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1340.09 352.03 1340.04 352.03 1340.09 351.99 1340.09 352.03"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1341.42 665.94 1341.42 666.07 1341.38 665.98 1341.34 665.94 1195.15 425.84 1195.82 425.53 1340.62 500.22 1340.71 500.27 1341.42 665.94"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1339.95 351.99 1340.04 352.03 1339.95 352.08 1339.95 351.99"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1485.56 424.59 1341.42 665.94 1341.38 665.98 1341.34 666.07 1341.34 665.94 1340.62 500.22 1340.71 500.27 1341.42 500.62 1484.26 425.17 1347.54 355.78 1485.56 424.59"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1484.26 425.17 1341.42 500.62 1340.71 500.27 1340.62 500.22 1195.82 425.53 1339.95 352.08 1340.04 352.03 1340.09 352.03 1347.54 355.78 1484.26 425.17"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1195.15 425.17 1339.95 352.08 1195.82 425.53 1195.15 425.17"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1347.54 355.78 1340.09 352.03 1340.04 352.03 1340.09 351.99 1347.54 355.78"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1339.6,
    cy: 433.6,
    rx: 53.62,
    ry: 15.68
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1367.89,426.86h0c-44.77,20.64-95.85-12.06-95.85-61.36v-1.07a67.56,67.56,0,0,1,39.34-61.39h0c44.37-20.4,95.06,11.56,95.78,60.39l0,1.06A67.56,67.56,0,0,1,1367.89,426.86Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1349.15,366.5a3.63,3.63,0,0,1-1.11-.18,3.37,3.37,0,0,1-1.71-1.24,3.43,3.43,0,0,1-.64-2v-4.28a7.26,7.26,0,0,1-6.09-7.15v-9.9a7.25,7.25,0,0,1,7.24-7.24h17.52a7.25,7.25,0,0,1,7.24,7.24v9.9a7.25,7.25,0,0,1-7.24,7.24h-7.8l-4.69,6.25A3.4,3.4,0,0,1,1349.15,366.5Zm-21.74,3.81a11.43,11.43,0,1,1,11.43-11.43A11.43,11.43,0,0,1,1327.41,370.31Zm-19.81,11.11c0,.14.23,14,19.81,14s19.81-13.89,19.81-14v-1.59a5.72,5.72,0,0,0-5.72-5.71h-28.19a5.71,5.71,0,0,0-5.71,5.71Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "169.46 350.14 169.42 350.14 169.46 350.09 169.46 350.14"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "170.8 664.04 170.8 664.17 170.76 664.09 170.71 664.04 24.53 423.94 25.2 423.63 170 498.33 170.09 498.37 170.8 664.04"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "169.33 350.09 169.42 350.14 169.33 350.18 169.33 350.09"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "314.93 422.69 170.8 664.04 170.76 664.09 170.71 664.17 170.71 664.04 170 498.33 170.09 498.37 170.8 498.73 313.64 423.27 176.91 353.88 314.93 422.69"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "313.64 423.27 234.67 464.99 170.8 498.73 170.09 498.37 170 498.33 25.2 423.63 169.33 350.18 169.42 350.14 169.46 350.14 176.91 353.88 313.64 423.27"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "24.53 423.27 169.33 350.18 25.2 423.63 24.53 423.27"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "176.91 353.88 169.46 350.14 169.42 350.14 169.46 350.09 176.91 353.88"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 170.02,
    cy: 433.6,
    rx: 53.62,
    ry: 15.68
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M198.31,426.86h0c-44.77,20.64-95.86-12.06-95.86-61.36v-1.07a67.57,67.57,0,0,1,39.35-61.39h0c44.37-20.4,95.06,11.56,95.78,60.39l0,1.06A67.56,67.56,0,0,1,198.31,426.86Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.36,375.8a3.59,3.59,0,0,1,2.56-1.07h1a1.09,1.09,0,0,0,.75-.3,1.12,1.12,0,0,0,.08-1.5,24.43,24.43,0,1,1,4.07,4.07,1.12,1.12,0,0,0-1.5.08,1.09,1.09,0,0,0-.3.75v1a3.59,3.59,0,0,1-1.07,2.56l-14.9,14.88a4,4,0,0,1-5.59-5.6Zm23.58-1.07a16.89,16.89,0,1,0-16.89-16.89A16.86,16.86,0,0,0,176.94,374.73Z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "759.88 497.49 759.84 497.49 759.88 497.45 759.88 497.49"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "761.22 811.4 761.22 811.53 761.17 811.44 761.13 811.4 614.95 571.3 615.62 570.99 760.42 645.68 760.5 645.73 761.22 811.4"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "759.75 497.45 759.84 497.49 759.75 497.54 759.75 497.45"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "905.35 570.05 761.22 811.4 761.17 811.44 761.13 811.53 761.13 811.4 760.42 645.68 760.5 645.73 761.22 646.08 904.06 570.63 767.33 501.24 905.35 570.05"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "904.06 570.63 761.22 646.08 760.5 645.73 760.42 645.68 615.62 570.99 759.75 497.54 759.84 497.49 759.88 497.49 767.33 501.24 904.06 570.63"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "614.95 570.63 759.75 497.54 615.62 570.99 614.95 570.63"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "767.33 501.24 759.88 497.49 759.84 497.49 759.88 497.45 767.33 501.24"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 758.83,
    cy: 573.62,
    rx: 53.62,
    ry: 15.68
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M787.13,566.88h0c-44.76,20.64-95.85-12.06-95.85-61.36v-1.07a67.57,67.57,0,0,1,39.35-61.39h0c44.37-20.4,95,11.56,95.78,60.39v1.06A67.56,67.56,0,0,1,787.13,566.88Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.85,522.17a2.64,2.64,0,0,1,4.47,1.87,2.64,2.64,0,0,1-.74,1.86l-4,4a8.32,8.32,0,0,1-2.68,1.78,8.24,8.24,0,0,1-9-1.78,2.94,2.94,0,0,0-4.19,0l-1.32,1.31a2.53,2.53,0,0,1-.85.6,2.74,2.74,0,0,1-1,.21,2.54,2.54,0,0,1-1-.2,2.68,2.68,0,0,1-.87-.57,2.82,2.82,0,0,1-.58-.87,2.72,2.72,0,0,1-.19-1,2.55,2.55,0,0,1,.21-1,2.81,2.81,0,0,1,.59-.86l1.32-1.32a8.38,8.38,0,0,1,2.67-1.78,8.22,8.22,0,0,1,6.31,0,8.27,8.27,0,0,1,2.67,1.78,2.86,2.86,0,0,0,1,.65,3,3,0,0,0,2.26,0,2.86,2.86,0,0,0,1-.65Zm-4.77-35.12a6.6,6.6,0,0,1,11.24,4.67,6.63,6.63,0,0,1-1.92,4.66l-30.54,30.54a4.11,4.11,0,0,1-1.72,1l-7.48,2.13a2.73,2.73,0,0,1-1.39,0,2.6,2.6,0,0,1-1.2-.69,2.69,2.69,0,0,1-.69-1.2,2.73,2.73,0,0,1,0-1.39l2.13-7.48a4.11,4.11,0,0,1,1-1.72Zm-27.66-7.88a2.57,2.57,0,0,1,1.53.5,2.63,2.63,0,0,1,1,1.29l.34,1a7.9,7.9,0,0,0,4.94,4.94l1,.34a2.65,2.65,0,0,1,1.29,1,2.63,2.63,0,0,1-1.29,4l-1,.35a7.89,7.89,0,0,0-4.93,4.93l-.35,1a2.63,2.63,0,0,1-2.49,1.78,2.66,2.66,0,0,1-1.54-.49,2.69,2.69,0,0,1-1-1.29l-.34-1a7.92,7.92,0,0,0-4.93-4.94l-1-.34a2.59,2.59,0,0,1-1.3-1,2.63,2.63,0,0,1-.49-1.53,2.66,2.66,0,0,1,.49-1.54,2.72,2.72,0,0,1,1.3-1l1-.34a7.89,7.89,0,0,0,4.93-4.94l.34-1a2.63,2.63,0,0,1,1-1.29A2.6,2.6,0,0,1,743.42,479.17Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 568.12,
    cy: 639.74,
    r: 9.84
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M687,607.44l-51.52,21.47a140.77,140.77,0,0,1-120.19-5.63L297.37,507.5l-66.82-37.78"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1262.18,
    cy: 487.61,
    r: 9.84
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M829.88,610.73,881.4,632.2a140.82,140.82,0,0,0,120.2-5.63l217.89-115.78L1286.31,473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMytermsthumbnail);
export default __webpack_public_path__ + "static/media/mytermsthumbnail.48efe99f9da87981c6b2dacc00d60fef.svg";
export { ForwardRef as ReactComponent };